// extracted by mini-css-extract-plugin
export default {"container":"payment_container__7KoMq","innerCon":"payment_innerCon__Egig5","btn":"payment_btn__X+iJh"};